import * as types from './constants';
import * as actions from '../../actions/actionTypes';
import {beginAjaxCall, ajaxCallError} from '../../actions/ajaxStatusActions';
import TimeTrackingAPI from '../../api/mockTimeTrackingApi';
import ProjectApi from '../../api/projectApi';

export function loadTimesheetSuccess(timeSheets) {
    return {type: types.LOAD_TIMESHEET_SUCCESS, timeSheets};
}

export function updateCourseSuccess(timeSheet) {
    return {type: types.UPDATE_TIMESHEET_SUCCESS, timeSheet};
}

export function createCourseSuccess(timeSheet) {
    return {type: types.CREATE_TIMESHEET_SUCCESS, timeSheet};
}

export function loadTimesheets() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return TimeTrackingAPI.getAllTimeTrackings().then(timeSheets => {
            dispatch(loadTimesheetSuccess(timeSheets));
        }).catch(error => {
            throw(error);
        });
    };
}

export function getMyProjects() {
    return function (dispatch) {
        return ProjectApi.getMyProjects().then(projects => {
            dispatch(getMyProjectsSuccess(projects));
        }).catch(error => {
            dispatch(getMyProjectsFailure(error));
        });
    };
}

function getMyProjectsSuccess(projects) {
    return { type: actions.GET_MY_PROJECTS_SUCCESS, projects };
}

function getMyProjectsFailure(error) {
    return { type: actions.GET_MY_PROJECTS_FAILURE, error };
}


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/actions.js
 **/